module.exports = __webpack_public_path__ + "img/icon-bullet-tick.ba3a0e94.svg";